module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0011.jpg?v=316e8e4a";